import { FormReviewData } from "@/types";
import { formatDate, getReviewerName } from "@/utils/formatters";

interface ReviewHeaderProps {
  formData: FormReviewData;
  isInIframe: boolean;
}

export function ReviewHeader({ formData, isInIframe }: ReviewHeaderProps) {
  if (isInIframe) return null;

  const reviewerName = getReviewerName(formData.currentReviewer);

  return (
    <div className="review-header-compact">
      <div className="header-title">
        <h1>{formData.travelerName}</h1>
        <span className={`status-badge ${formData.formStatus}`}>
          {formData.formStatus}
        </span>
      </div>
      <div className="header-details">
        <span>#{formData.consultationNumber}</span>
        <span>{formatDate(formData.submittedAt)}</span>
        {reviewerName && <span>Reviewer: {reviewerName}</span>}
      </div>
    </div>
  );
}
